import { render } from "./HeroiconsSolidMinus.vue?vue&type=template&id=6b9f432c"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMinus.vue"]])

export default __exports__